import PropTypes from 'prop-types';
import React from 'react';

import styles from './firmware-update-dialog.css';

const DeviceMismatchDialog = ({
    connectedLabel,
    message,
    onAccept,
    onClose,
    selectedLabel,
    title
}) => (
    <div className={styles.overlay}>
        <div className={styles.modal}>
            <button
                aria-label="Close"
                className={styles.closeButton}
                onClick={onClose}
            />
            <div className={styles.header}>
                <h2>{title}</h2>
            </div>

            <div className={styles.content}>
                <div className={styles.deviceInfo}>
                    <div className={styles.versionComparison}>
                        <div className={styles.versionBox}>
                            <span className={styles.versionLabel}>{'Selected'}</span>
                            <span className={styles.versionNumber}>{selectedLabel}</span>
                        </div>
                        <div className={styles.arrow}>{'→'}</div>
                        <div className={styles.versionBox}>
                            <span className={styles.versionLabel}>{'Connected'}</span>
                            <span className={`${styles.versionNumber} ${styles.latest}`}>{connectedLabel}</span>
                        </div>
                    </div>
                </div>

                <div className={styles.message}>
                    <p>{message}</p>
                </div>

                <div className={styles.actions}>
                    <button
                        className={styles.updateButton}
                        onClick={onAccept}
                    >
                        {'YES'}
                    </button>
                </div>
            </div>
        </div>
    </div>
);

DeviceMismatchDialog.defaultProps = {
    message: 'Would you like to continue with the connected device?',
    title: 'Device mismatch found'
};

DeviceMismatchDialog.propTypes = {
    connectedLabel: PropTypes.string.isRequired,
    message: PropTypes.string,
    onAccept: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedLabel: PropTypes.string.isRequired,
    title: PropTypes.string
};

export default DeviceMismatchDialog;
